export default function HowIsItUsed() {
    return {
        title: 'How is it used',
        paragraphs: [
            '<div>Term life insurance protects your clients and their family against life’s unknowns for a specified period of time.</div>',
        ]
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/term/HowIsItUsedData.js